import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { IReportsRise, ReportsServicesRise } from '../../../../services/api/reports/ReportsServicesRise';
import { Loadin } from '../../../shared';
import { useEffect, useState } from 'react';
import { formatDateWhitoutHour } from '../../../../services/helpers/helpers';

interface ICardRise {
    data: IReportsRise
}

export const CardRise = ({ data }: ICardRise) => {

    const uuid = data.uuid;
    const [rise, setRise] = useState<IReportsRise>();

    useEffect(() => {
        fetchData();
    }, [uuid]);

    const fetchData = () => {
        if (uuid) {
            ReportsServicesRise.get(uuid)
                .then((result) => {
                    if (result instanceof Error) {
                        console.log(result.message);
                    } else {
                        setRise(result);
                    }
                });
        }
    };

    if (rise == undefined) {
        return (
            <Box>
                <Loadin />
            </Box>
        );
    }

    return (
        <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'} padding={1}>

            <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant='subtitle1' component='h6'>Geral</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid>
                        <Grid container alignContent={'center'} spacing={2} gap={2}>
                            <Grid container gap={2} padding={1}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.motivo}
                                            label='Motivo da inspeção'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.empresa_executora}
                                            label='Empresa executora'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={formatDateWhitoutHour(rise.data_inspecao)}
                                            label='Data de inspeção'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={formatDateWhitoutHour(rise.data_dce)}
                                            label='Data de DCE'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.status_dce}
                                            label='Status do protocolo (DCE/EISR)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.responsavel}
                                            label='Responsável técnico'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.status_dce}
                                            label='Status do protocolo (DCE/EISR)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.art}
                                            label='ART (número)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.orgao}
                                            label='Órgão fiscalizador'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.dpa}
                                            label='Dano Potencial Associado (DPA)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.cri}
                                            label='Categoria de Risco (CRI)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={rise.classificacao}
                                            label='Classificação (conforme órgão fiscalizador)'
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {rise.analiseEstabilidade !== undefined ? (
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1' component='h6'>Análises de Estabilidade</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container alignContent={'center'} spacing={2} gap={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={rise.analiseEstabilidade.metodo_analise}
                                    label='Métodos de análise'
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={rise.analiseEstabilidade.modos_falha}
                                    label='Modos de falha'
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Divider />
                            {rise.analiseEstabilidade.informacoes && rise.analiseEstabilidade.informacoes.length > 0 ? (
                                rise.analiseEstabilidade.informacoes.map((info, index) => (
                                    <Grid container spacing={2} key={index} padding={1}>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.condicao}
                                                label='Condição'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.fator_seguranca}
                                                label='Fator de segurança'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.secao}
                                                label='Seção'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={info.valor_referencia}
                                                label='Valor de referência'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))
                            ) : null}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {rise.verificacaoHidrologica !== undefined ? (
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1' component='h6'>Verificação Hidrológica/Hidráulica</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            <Grid container alignContent={'center'} spacing={2} gap={2}>
                                <Grid container gap={2} padding={1}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.area_drenagem}
                                                label='Área de drenagem'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.bombeamento}
                                                label='Bombeamento'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.borda_livre}
                                                label='Borda livre'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.duracao_chuva}
                                                label='Duração da chuva'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.na_maximo_maximorum}
                                                label='NA maximo'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.na_maximo_operacional}
                                                label='NA maximo operacional'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.precipitacao_pmp}
                                                label='Precipitação PMP'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.precipitacao_projeto}
                                                label='Precipitação do projeto'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                value={rise.verificacaoHidrologica.vazao_maxima}
                                                label='Vazão maxima'
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {rise.monitoramentos.length > 0 ? (
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1' component='h6'>Interpretação dos Monitoramentos</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {rise.monitoramentos.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.destaque}
                                                    label='Destaque'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.tipo}
                                                    label='Tipo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {rise.anomalias.length > 0 ? (
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1' component='h6'>Avaliação das Anomalias</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {rise.anomalias.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.anomalia}
                                                    label='Anomalia'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.avaliacao}
                                                    label='Avaliação'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {rise.recomendacoes.length > 0 ? (
                <Accordion variant='outlined' square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='subtitle1' component='h6'>Recomendações</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid >
                            {rise.recomendacoes.map((item, index) => (
                                <Grid container alignContent={'center'} spacing={2} gap={2} key={index}>
                                    <Grid container gap={2} padding={1}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={item.recomendacao}
                                                    label='Recomendação'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    value={formatDateWhitoutHour(item.prazo)}
                                                    label='Prazo'
                                                    fullWidth
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : null}
        </Box>
    );
};